export default __webpack_public_path__ + "static/media/hht2_Intonation_20.36837188.png";